import "@js/product/index";
document.addEventListener("DOMContentLoaded", function() {
  window.handleSelectChange = function(select, id) {
    var input = document.getElementById("customNumberInput-" + id);
    if (select.value === "9+") {
      select.style.display = "none";
      input.style.display = "inline-block";
      input.focus();
    } else {
      select.style.display = "inline-block";
      input.style.display = "none";
      input.value = "";
    }
  };
  window.handleInputChange = function(input, id) {
    var select = document.getElementById("numberSelect-" + id);
    var customOption = select.querySelector("#customOption-" + id);
    if (customOption) {
      customOption.value = input.value;
      customOption.text = input.value;
    } else {
      var option = document.createElement("option");
      option.id = "customOption-" + id;
      option.value = input.value;
      option.text = input.value;
      select.add(option);
    }
    select.value = input.value;
  };
});
